import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/gestion-icsr")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/gestion-icsr", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/pharmacovigilance/gestion-icsr", replace: true });
  },
});
